













































import { Component, Mixins } from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component
export default class EmailConfirmationAfterRegister extends Mixins(IsMobileMixin) {
    get email(): string {
        if (this.$route.query.email) {
            return (this.$route.query.email as string);
        }
        return '';
    }
}
